import { render, staticRenderFns } from "./ArtistProfileInner.vue?vue&type=template&id=28fba5a2&scoped=true"
import script from "./ArtistProfileInner.vue?vue&type=script&lang=js"
export * from "./ArtistProfileInner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fba5a2",
  null
  
)

export default component.exports